
import Copyright from "../components/Copyright";
/*import NavBar from "../components/nav/NavBar";*/
import Stripe from "../components/splash/Stripe";


export default function Unipage(props) {
	return (
		<div className="container-flex">
			<header className="row m-0 p-0" role="banner">
				<Stripe color="#f0e060" height="1.5em" />
				<div className="col-12 col-xs-12 col-sm-12 col-md-11 col-lg-10 col-xl-9 mx-auto p-4">
					<a title="Img2pdf - Convert Image to PDF, PNG to PDF, JPG to PDF, GIF to PDF, WEBP to PDF, TIFF to PDF, BMP to PDF, and more!" href="/">
						<img width="200px" height="50px" className="main-logo" src="/img/img2pdfv4-64px.png" alt="img2pdf"></img>
					</a>
				</div>	
			</header>
			<main className="row m-0 p-0" role="main">
				<div className="col-12 col-xs-12 col-sm-12 col-md-11 col-lg-10 col-xl-9 mx-auto p-3">
					{props.content}
				</div>
			</main>
			<footer className="row m-0 p-0" role="contentinfo">
				<div className="col-12 col-xs-12 col-sm-12 col-md-11 col-lg-10 col-xl-9 mx-auto p-3">
					<Copyright />
				</div>
				<Stripe color="#f0e060" height="1.5em" />
			</footer>
		</div>
	);
}